module.exports = __webpack_public_path__ + "img/text-classify6.78999ce2.png";